module.exports = "../images/icons/home-address.svg";